import UserService from "../services/user.service";

export const user = {
	namespaced: true,
	state: {
		profile: {},
	},
	actions: {
		async getProfile({ commit, dispatch }) {
			try {
				let userData = await UserService.getUserProfile();
				commit("auth/UPDATE_USER", userData.data, { root: true });
				commit("UPDATE_PROFILE", userData.data.profile);
				return userData.data;
			} catch (err) {
				if (err.response) {
					if ([401, 403, 404].includes(err.response.status)) {
						dispatch("auth/logout", {}, { root: true });
					}
				}
			}
		},

		async loginStatus({ dispatch }) {
			try {
				let loginStatus = await UserService.loginStatus();
				return loginStatus.data;
			} catch (err) {
				if (err.response) {
					if ([401, 403, 404].includes(err.response.status)) {
						dispatch("auth/logout", {}, { root: true });
						return false;
					}
				}
			}
		},
	},
	mutations: {
		UPDATE_PROFILE(state, profile) {
			state.profile = profile;
		},
	},
	getters: {
		GET_PROFILE(state) {
			return state.profile;
		},
	},
};
